export const getDataLabelsStyle = (stacking, showDataLabels) => (!stacking || stacking === 'percent') && showDataLabels;
export const getStackLabelStyle = (stacking, showDataLabels) => stacking && stacking !== 'percent' && showDataLabels;